import React, { FC } from 'react';
import TSPriorityDisplay from './TSPriorityDisplay';
import OWTag from '../../common/OWTag';

// See TSLocationsDisplay for the wire contract on `*Ids` props.
const TSPrioritiesDisplay: FC<any> = ({ priorities = [], workOrderPriorityIds, notSpecified }) => {
	const isNoneConfigured = workOrderPriorityIds === undefined || workOrderPriorityIds === null;
	return (
		<div className="flex flex-row flex-wrap items-center gap-2">
			{isNoneConfigured ? (
				<OWTag>{'No Priorities'}</OWTag>
			) : priorities.length > 0 ? (
				priorities.map((p, idx) => <TSPriorityDisplay key={`ts-priority-${idx}`} priority={p} />)
			) : (
				<>
					<OWTag>{'All Priorities'}</OWTag>
				</>
			)}
		</div>
	);
};

export default TSPrioritiesDisplay;
